import { Navigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { Crown, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const Loader = () => (
  <div data-testid="page-loader" className="flex min-h-[60vh] items-center justify-center">
    <div className="h-8 w-8 animate-spin rounded-full border-2 border-red-600 border-t-transparent" />
  </div>
);

export function ProtectedRoute({ children, admin = false }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (!user.profile_complete && loc.pathname !== "/onboarding") return <Navigate to="/onboarding" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/discover" replace />;
  return children;
}

const RANK = { free: 0, member: 1, vip: 2 };

export function TierGate({ tier, children, title }) {
  const { user } = useAuth();
  if (RANK[user?.membership || "free"] >= RANK[tier]) return children;
  return (
    <div data-testid={`tier-gate-${tier}`} className="card-lux mx-auto my-16 max-w-xl p-10 text-left">
      {tier === "vip" ? <Crown className="mb-6 h-8 w-8 text-amber-400" /> : <Lock className="mb-6 h-8 w-8 text-red-500" />}
      <p className="eyebrow mb-3">{tier === "vip" ? "VIP · $19.99 / month" : "Member · $9.99 / month"}</p>
      <h2 className="font-display mb-4 text-4xl">{title || "Unlock this experience"}</h2>
      <p className="mb-8 text-zinc-400">
        {tier === "vip"
          ? "VIP unlocks live cams, the cash exchange wallet, and selling exclusive content."
          : "Membership unlocks messaging and worldwide dating."}
      </p>
      <Link to="/membership" data-testid="tier-gate-upgrade-btn" className="btn-red inline-block rounded-full px-8 py-3 text-sm font-semibold">
        Upgrade now
      </Link>
    </div>
  );
}
